export default ['🤑', '🤩', '😍', '😎', '🤑', '😃', '😄'];
